'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidDrafts = function IoAndroidDrafts(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 15.8v15.8c0 1.8-1.6 3.4-3.4 3.4h-28.2c-1.8 0-3.4-1.6-3.4-3.4v-15.8c0-1.2 0.6-2.4 1.6-2.9l15.9-7.9 15.9 7.9c1.1 0.5 1.6 1.7 1.6 2.9z m-17.5 8l13.4-8.8-13.4-6.6-13.4 6.6z' })
        )
    );
};

exports.default = IoAndroidDrafts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-drafts.js
// module id = 1885
// module chunks = 0